
export const classResponsiveForm = "px-2 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2";
export const classResponsiveFormShort = "px-2 col-xs-12 col-sm-3 col-md-3 col-lg-2 col-xl-1";
export const classResponsiveFormWithoutPaddingX = "px-0 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2";
export const classResponsiveFormWidthHeader = "px-2 col-xs-12 col-sm-7 col-md-5 col-lg-4 col-xl-3";
export const classResponsiveFormDoubleWidth = "px-2 col-xs-12 col-sm-12 col-md-8 col-lg-6 col-xl-4";
export const classResponsiveFormDoubleWidthHeader = "px-2 col-xs-12 col-sm-14 col-md-10 col-lg-8 col-xl-6";
export const classResponsiveFormDoubleWidthHeaderWithoutPaddingX = "col-xs-12 col-sm-14 col-md-10 col-lg-8 col-xl-6";

export const optionsExample = [
    {id: 10, text: "Example 1"},
    {id: 20, text: "Example 2"},
    {id: 30, text: "Example 3"}
]

export const optionsEstados = [
    {text: "Activo", value: 1},
    {text: "Inactivo", value: 0}
]

export const optionsEstadosSelect = [
  {text: "Activo", id: 1},
  {text: "Inactivo", id: 0}
]

export const optionsYesNo = [
    {text: "Si", value: 'S'},
    {text: "No", value: 'N'}
]

export const optionsYesNoResponseBinary = [
    {text: "Si", value: 1},
    {text: "No", value: 0}
]

export const optionsYesNoResponse = [
    {text: "Si", id: 1},
    {text: "No", id: 0}
]

export const optionsFrecuencia = [
    {id: 1, text: "Diario"},
    {id: 7, text: "Semanal"},
    {id: 15, text: "Quincenal"},
    {id: 30, text: "Mensual"},
]

export const optionsEtiquetas = [
    {id: 200, text: "200"}
]

export const optionsPrioridadMercancia = [
    {id: 1, text: "1"},
    {id: 2, text: "2"},
    {id: 3, text: "3"},
    {id: 4, text: "4"},
    {id: 5, text: "5"}
]

export const optionsIVAProductos = [
    {id: 0, text: "0"},
    {id: 5, text: "5"},
    {id: 10, text: "10"},
    {id: 19, text: "19"}
]

export const optionsTiposDocumento = [
  {
    id: "CC",
    text: "Cédula Ciudadania"
  },
  {
    id: "RUT",
    text: "RUT"
  },
  {
    id: "CamaraComercio",
    text: "Camara de comercio"
  },
  {
    id: "FotoNegocioInt",
    text: "Foto Negocio Interna"
  },
  {
    id: "FotoNegocioExt",
    text: "Foto Negocio Externa"
  },
  {
    id: "FotoDocHabeasData",
    text: "Foto Documento Habeas Data"
  }
]


export const ERRORFIELDREQUIRED = "*Campo Obligatorio"
export const ERROREMAILFIELDREQUIRED = "*Email Invalido"

